export const ALL_TASK_REQUEST = "allTask/allTaskRequest";
export const ALL_TASK_SUCCESS = "allTask/allTaskSuccess";
export const ALL_TASK_ERROR = "allTask/allTaskError";